var map = {
	"./_design.svg": "876c",
	"./_www.svg": "8c65",
	"./arrow.svg": "b94f",
	"./design.svg": "186c",
	"./graphic.svg": "669e",
	"./logo-text.svg": "1615",
	"./logo.svg": "9b19",
	"./menu-bars.svg": "fab8",
	"./photography.svg": "0cf5",
	"./portfolio-graphic-bg.svg": "89b2",
	"./skew.svg": "a8d0",
	"./www.svg": "7296"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";